import __isEmpty from 'lodash/isEmpty';
import styles from './aquipodras.module.scss';

const AquiPodras = (props) => {
    const { items, titol = 'Aquí podràs:' } = props;
    return (
        <div className={styles.aquiPodrasWrapper}>
            <div className={styles.aquiPodrasTitol}>
                <div className={styles.aquiPodrasTextTitol}>{titol}</div>
                <div className={styles.aquiPodrasFletxa} />
            </div>
            {items.map((text, i) => (
                <div key={`aquipodras-${i}`} className={styles.aquiPodrasText}>
                    <span>{text}</span>
                    <div className={styles.aquiPodrasFletxa} />
                </div>
            ))}
        </div>
    );
};

export default AquiPodras;
